import React, { useEffect, useState } from "react";
import MyModal from "react-bootstrap/Modal";

const Modal = (props) => {
  const [show, setShow] = useState(props.show);
  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <MyModal
      show={show}
      onHide={props.close}
      centered
      className={`${props.className} ${props.backdropClassName}`}
      backdropClassName={props.backdropClassName}
    >
      <MyModal.Header closeButton>
        <MyModal.Title>{props.title}</MyModal.Title>
      </MyModal.Header>
      <MyModal.Body className={`${props["footer-margin"]}`}>
        {props.children}
      </MyModal.Body>
    </MyModal>
  );
};

export default Modal;
